import { render, staticRenderFns } from "./AuthenticationCompleted.vue?vue&type=template&id=a917b4fe&"
var script = {}
import style0 from "./AuthenticationCompleted.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports